export default __webpack_public_path__ + "static/media/7.22a22be8.jpg";